(function( $ ) {

    $('#contact-form').submit(function(e){
        e.preventDefault();
        $("#contact-error").html('');
        $("#contact-success").addClass('d-none');
    });

    $('#contact-form').validate({
        rules: {
            name: {
                required: true,
                customText: true,
                maxlength: 30,
            },
            email: {
                required: true,
                customEmail: true,
                maxlength: 30,
            },
            contact: {
                phoneNumber: true,
                minlength: 9,
                maxlength: 14,
            },
            country: {
                required: true,
            },
            message: {
                required: true,
                maxlength: 500,
            }
        },
        // messages: { },
        submitHandler: function (form) {

            var name = $(form).find('input[name="name"]').val();
            var email = $(form).find('input[name="email"]').val();
            var contact = $(form).find('input[name="contact"]').val();
            var country = $(form).find('select[name="country"]').val();
            var message = $(form).find('textarea[name="message"]').val();
            var csrfToken = $(form).find('input[name="csrfToken"]').val();

            $.ajax({
                type: "POST",
                url: "includes/contact-process.php",
                data: {
                    name: name, 
                    email: email, 
                    contact: contact, 
                    country: country, 
                    message: message, 
                    token: csrfToken 
                },
                dataType: 'json',
                beforeSend: function() {
                    $('#content-preloader').show();
                }, 
                complete: function() {
                    $('#content-preloader').fadeOut(500);
                },
                success: function(data){
                    //console.log(data);        
                    var msg = JSON.parse(JSON.stringify(data));
                    if (msg.success == true) {
                        $("#contact-success").removeClass('d-none');
                        $(".left-column").animate({ scrollTop: 0 }, "slow");
                    } else {
                        $("#contact-error").html('<div class="alert alert-danger" role="alert">'+msg.reason+'</div>');
                        $(".left-column").animate({ scrollTop: 0 }, "slow");
                    }
                },
                error: function(XMLHttpRequest, textStatus, errorThrown) { 
                    console.log("Status: " + textStatus); 
                    console.log("Error: " + errorThrown);
                    console.log(XMLHttpRequest.responseText)
                }
            });
            return false;
        }
    });


}(jQuery));
